import { Component, ElementRef, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SearchAutoSuggestService } from './services/search-auto-suggest.service';
import { formatLabel } from '@project/shared/utils/labels/js/labels';
var FILTER_PRODUCTSEARCH_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return FilterProductSearchComponent; }),
    multi: true,
};
var KEYPRESS_THRESHOLD = 300; // in milliseconds. used to prevent spaming of ajax requests
var REQUEST_TIMEOUT;
var LAST_SEARCH_PHRASE;
var FilterProductSearchComponent = /** @class */ (function () {
    function FilterProductSearchComponent(elementRef, searchAutoSuggestService) {
        this.elementRef = elementRef;
        this.searchAutoSuggestService = searchAutoSuggestService;
        // TODO: Refactor to external enum
        this.KEY_UP_CODE = 38;
        this.KEY_DOWN_CODE = 40;
        this.KEY_ENTER_CODE = 13;
        this.KEY_ESC_CODE = 27;
        /**
         * Event Emitter - Fires searchChanges event, which can be handled in parent component.
         */
        this.searchChanges = new EventEmitter();
        /**
         * The current open state of the dropdown.
         */
        this._isOpen = false;
        /**
         * The current searching for suggestion state of the search field.
         */
        this._isSearching = false;
        /**
         * True, when control has focus.
         */
        this._isFocused = false;
    }
    /**
     * Event - Fires when a click happens on the document.
     * If the click was outside of the control, the dropdown should close
     * @param event
     */
    FilterProductSearchComponent.prototype.onHostClick = function (event) {
        if (this._isOpen && !this.elementRef.nativeElement.contains(event.target)) {
            this._isOpen = false;
            this._isFocused = false;
        }
    };
    /**
     * Event - Fires when the filter selection is confirmed.
     */
    FilterProductSearchComponent.prototype.onSearchChange = function () {
        this.searchChanges.emit(this._searchText);
        this.onToggleSelect();
    };
    /**
     * Event - Fires when the filter was clicked.
     * Toggles the
     */
    FilterProductSearchComponent.prototype.onToggleSelect = function () {
        if (this._searchText && this._searchText.length > 0) {
            this._isOpen = !this._isOpen;
        }
    };
    /**
     * Event - Fires when user selects an item from list.
     * @param item
     */
    FilterProductSearchComponent.prototype.onSelect = function (item) {
        if (item) {
            if (!item.disabled) {
                this._searchText = item.value;
            }
            if (typeof item === 'string') {
                this._searchText = item;
            }
        }
        this._isOpen = false;
        this.searchChanges.emit(this._searchText);
    };
    /**
     * Event - Fires when user has released a key after keypress. Does:
     * - arrow-key navigation through items
     * - select on enter
     * - call api if searchText is valid and load dropdown
     *
     * @param item
     */
    FilterProductSearchComponent.prototype.onKeyUp = function (event) {
        var keyCode = window.event ? event.which : event.keyCode;
        if (keyCode === this.KEY_ESC_CODE) {
            this.handleKeyEsc();
        }
        else if (keyCode === this.KEY_ENTER_CODE) {
            this.handleKeyEnter();
        }
        else if (keyCode === this.KEY_DOWN_CODE || keyCode === this.KEY_UP_CODE) {
            if (this._data && this._data.length > 0) {
                var enabledElements = this._data.filter(function (item) { return !item.disabled; });
                if (enabledElements) {
                    if (keyCode === this.KEY_DOWN_CODE) {
                        this.handleKeyDown(enabledElements);
                    }
                    else if (keyCode === this.KEY_UP_CODE) {
                        this.handleKeyUp(enabledElements);
                    }
                }
            }
        }
        else {
            this.onSearch();
        }
    };
    FilterProductSearchComponent.prototype.onSearchIconClick = function () {
        if (this.checkIfNewSearchString()) {
            console.log("onSearchIconClick---");
            this.onSelect(this._searchText);
        }
    };
    FilterProductSearchComponent.prototype.checkIfNewSearchString = function () {
        var arrayOfQueryStrings = window.location.search !== undefined ? window.location.search.split(":") : null;
        if (arrayOfQueryStrings !== null) {
            var queryString = arrayOfQueryStrings[0];
            if (queryString !== "?query=" + this._searchText) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    };
    FilterProductSearchComponent.prototype.onSearchItemClick = function (item) {
        if (this.checkIfNewSearchString()) {
            console.log("onSearchItemClick---");
            this.onSelect(item);
        }
    };
    FilterProductSearchComponent.prototype.onSearchClearIconClick = function () {
        this._searchText = '';
        if (this.checkIfNewSearchString()) {
            this.onSelect(this._searchText);
        }
    };
    /**
     * Search brand/product with current value bound to the search-input.
     */
    FilterProductSearchComponent.prototype.onSearch = function () {
        var _this = this;
        // if searchText is not null/undefined, then call api
        if (this._searchText) {
            if (this._searchText !== LAST_SEARCH_PHRASE) {
                // search for brand
                if (REQUEST_TIMEOUT) {
                    clearTimeout(REQUEST_TIMEOUT);
                }
                REQUEST_TIMEOUT = setTimeout(function () {
                    var ACTUAL_REQUEST_TIMEOUT = REQUEST_TIMEOUT;
                    _this.searchAutoSuggestService
                        .getLookupDataFromApi(_this.searchConfig, _this.lang, _this._searchText, _this.permissionQuery, _this.countryConfig)
                        .subscribe(function (data) {
                        // only change data if it's last triggered timeout
                        if (REQUEST_TIMEOUT === ACTUAL_REQUEST_TIMEOUT) {
                            _this._data = [];
                            _this._markedIndex = null;
                            _this._isOpen = false;
                            // only add new data as long searchtext is not empty
                            // => because API-Call lasts some time before callback action is done,
                            //    it could happen, that the searchText is null or empty meanwhile (so don't show anything)
                            if (data && _this._searchText) {
                                _this.handleSearchResponse(data);
                                _this._isOpen = true;
                                _this._isSearching = false;
                            }
                        }
                    });
                }, KEYPRESS_THRESHOLD);
                LAST_SEARCH_PHRASE = this._searchText;
                this._isSearching = true;
            }
        }
        else {
            // if searchText is null or empty, empty dropdown and close it
            this._data = [];
            this._markedIndex = null;
            this._isOpen = false;
            this._isSearching = false;
            this.onSelect(this._searchText);
            if (REQUEST_TIMEOUT) {
                clearTimeout(REQUEST_TIMEOUT);
            }
        }
    };
    /**
     * Event - Fires when hovering with mouse over the list items.
     */
    FilterProductSearchComponent.prototype.onMouseHover = function (item) {
        this._isFocused = true;
        if (!item.disabled) {
            this._markedIndex = item.index;
        }
        else {
            this._markedIndex = null;
        }
    };
    /**
     * Checks, if current item is marked (e.g. because of hover or arrow-key-navigation).
     * Used in template.
     * @param item
     */
    FilterProductSearchComponent.prototype.checkIsMarked = function (item) {
        return this._markedIndex === item.index && !item.disabled;
    };
    FilterProductSearchComponent.prototype.isShowAll = function (item) {
        return item && item.name === this.searchConfig.showAllResultsLabel;
    };
    FilterProductSearchComponent.prototype.focusInput = function () {
        this._isFocused = true;
    };
    FilterProductSearchComponent.prototype.blurInput = function () {
        this._isFocused = false;
    };
    FilterProductSearchComponent.prototype.handleSearchResponse = function (data) {
        if ((!data.suggestions || data.suggestions.length <= 0) &&
            (!data.productSuggestions || data.productSuggestions.length <= 0)) {
            var noResultsLabel = formatLabel(this.searchConfig.noResultsMessage, "<b>" + this._searchText + "</b>");
            var noResultsMessage = this.getDropDownElement(noResultsLabel, noResultsLabel, true, -1, true);
            this._data.push(noResultsMessage);
        }
        else {
            this._data.push(this.getDropDownElement(this.searchConfig.showAllResultsLabel, this._searchText, false, this._data.length));
            if (data.suggestions && data.suggestions.length > 0) {
                this.addSuggestionToData(data.suggestions, this.searchConfig.brandSuggestionsLabel);
            }
            if (data.productSuggestions && data.productSuggestions.length > 0) {
                this.addSuggestionToData(data.productSuggestions, this.searchConfig.productSuggestionsLabel);
            }
        }
    };
    FilterProductSearchComponent.prototype.addSuggestionToData = function (suggestions, suggestionLabel) {
        var _this = this;
        if (suggestions) {
            this._data.push(this.getDisabledDropDownElement(suggestionLabel));
            var index_1 = this._data.length;
            suggestions
                .map(function (item) { return item.value; })
                .map(function (term) {
                var elem = _this.getEnabledDropDownElement(term, index_1);
                index_1++;
                return elem;
            })
                .forEach(function (elem) { return _this._data.push(elem); });
        }
    };
    FilterProductSearchComponent.prototype.getEnabledDropDownElement = function (text, index) {
        if (index === void 0) { index = -1; }
        return this.getDropDownElement(text, text, false, index);
    };
    FilterProductSearchComponent.prototype.getDisabledDropDownElement = function (text, index) {
        if (index === void 0) { index = -1; }
        return this.getDropDownElement(text, text, true, index);
    };
    FilterProductSearchComponent.prototype.getDropDownElement = function (text, value, disabled, index, noResults) {
        if (noResults === void 0) { noResults = false; }
        return {
            index: index,
            name: text,
            value: value,
            disabled: disabled,
            noResults: noResults,
        };
    };
    FilterProductSearchComponent.prototype.handleKeyEsc = function () {
        this._isOpen = false;
        this._markedIndex = null;
    };
    FilterProductSearchComponent.prototype.handleKeyEnter = function () {
        if (this.checkIfNewSearchString()) {
            this._isOpen = false;
            this._isSearching = false;
            if (REQUEST_TIMEOUT) {
                clearTimeout(REQUEST_TIMEOUT);
            }
            if (this._markedIndex) {
                this.onSelect(this._data[this._markedIndex]);
            }
            else {
                this.onSelect(this._searchText);
            }
        }
    };
    FilterProductSearchComponent.prototype.handleKeyUp = function (enabledElements) {
        var _this = this;
        if (this._markedIndex != null && this._markedIndex >= 0) {
            var nextElements = enabledElements.filter(function (item) { return item.index < _this._markedIndex; });
            this._markedIndex = nextElements[nextElements.length - 1]
                ? nextElements[nextElements.length - 1].index
                : null;
        }
        else {
            this._markedIndex = enabledElements[enabledElements.length - 1].index;
        }
    };
    FilterProductSearchComponent.prototype.handleKeyDown = function (enabledElements) {
        var _this = this;
        if (this._markedIndex != null && this._markedIndex >= 0) {
            if (this._data && this._data.length - 1 > this._markedIndex) {
                var nextElements = enabledElements.filter(function (item) { return item.index > _this._markedIndex; });
                this._markedIndex = nextElements[0] ? nextElements[0].index : null;
            }
            else {
                this._markedIndex = null;
            }
        }
        else {
            this._markedIndex = enabledElements[0] ? enabledElements[0].index : null;
        }
    };
    Object.defineProperty(FilterProductSearchComponent.prototype, "disabled", {
        get: function () {
            return this._disabled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "isOpen", {
        get: function () {
            return this._isOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "isSearching", {
        get: function () {
            return this._isSearching;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "markedIndex", {
        get: function () {
            return this._markedIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "isFocused", {
        get: function () {
            return this._isFocused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilterProductSearchComponent.prototype, "data", {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
        },
        enumerable: true,
        configurable: true
    });
    FilterProductSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-filter-productsearch',
                    // FIXME: https://angular.io/styleguide#style-06-03
                    // tslint:disable
                    host: { '(document:click)': 'onHostClick($event)' },
                    providers: [FILTER_PRODUCTSEARCH_VALUE_ACCESSOR],
                    template: "<div class=\"m-filter-productsearch {{ modifier && 'm-filter-productsearch--' + modifier || modifier }}\"\r\n\t data-t-name=\"FilterProductSearch\"\r\n\t [attr.data-t-decorator]=\"decorator\"\r\n\t [ngClass]=\"{'m-filter-productsearch--is-searching' : isSearching}\">\r\n\t <div class=\"m-filter-productsearch__label\" *ngIf=\"modifier\" >\r\n\t\t<label data-t-name=\"Label\" class=\"a-label state-a-label--is-floated\" >Keywords</label>\r\n    </div>\r\n\t<div class=\"m-filter-productsearch__search-box\"\r\n\t\t [ngClass]=\"{'m-filter-productsearch__search-box--is-focused': isFocused }\">\r\n\t\t<input type=\"text\"\r\n\t\t\t   [placeholder]=\"placeholder\"\r\n\t\t\t   class=\"m-filter-productsearch__input\"\r\n\t\t\t   [disabled]=\"disabled\"\r\n\t\t\t   [ngClass]=\"{'m-filter-productsearch__input--disabled': disabled}\"\r\n\t\t\t   [(ngModel)]=\"searchText\"\r\n\t\t\t   (keyup)=\"onKeyUp($event)\"\r\n\t\t\t   (focus)=\"focusInput()\"\r\n\t\t\t   (blur)=\"blurInput()\"/>\r\n\t\t<cov-loading-indicator class=\"m-filter-productsearch__loader\"></cov-loading-indicator>\r\n\t\t<div class=\"m-filter-productsearch__search-box--input-wrapper\" (click)=\"onSearchIconClick()\" *ngIf=\"!searchText\">\r\n\t\t\t<span class=\"m-filter-productsearch__search-box--input-wrapper-icon\"></span>\r\n\t\t</div>\r\n\t\t<div class=\"m-filter-productsearch__search-box--input-wrapper\" (click)=\"onSearchClearIconClick()\" *ngIf=\"searchText\">\r\n\t\t\t<span class=\"m-filter-productsearch__search-box--input-wrapper-clear-icon\"></span>\r\n\t\t</div>\r\n\t\t<div class=\"m-filter-productsearch__button-wrapper\"  *ngIf=\"modifier\" >\r\n\t\t\t<cov-button\r\n\t\t\t\t[modifier]=\"'primary'\"\r\n\t\t\t\t[text]=\"searchButtonText\"\r\n\t\t\t\t[emitEvent]=\"true\"\r\n\t\t\t\t(buttonClick)=\"onSearchIconClick()\">\r\n\t\t\t</cov-button>\r\n\t\t</div>\r\n\t</div>\r\n\r\n\t<ul class=\"m-filter-productsearch__dropdown\"\r\n\t\t[ngClass]=\"[isOpen ? 'm-filter-productsearch__dropdown--is-open' : 'm-filter-productsearch__dropdown--is-closed', isFocused ? 'm-filter-productsearch__dropdown--is-focused' : '']\">\r\n\t\t<ng-container *ngFor=\"let item of data\">\r\n\t\t\t<li *ngIf=\"!item.disabled\"\r\n\t\t\t\tclass=\"m-filter-productsearch__dropdown-item\"\r\n\t\t\t\t(mouseenter)=\"onMouseHover(item)\"\r\n\t\t\t\t[ngClass]=\"{'m-filter-productsearch__dropdown-item--is-marked': checkIsMarked(item), 'm-filter-productsearch__dropdown-item--show-all' : isShowAll(item)}\"\r\n\t\t\t\t(click)=\"onSearchItemClick(item)\"\r\n\t\t\t\t[innerHtml]=\"item.name | highlight : searchText\">\r\n\t\t\t</li>\r\n\t\t\t<li *ngIf=\"item.disabled || item.noResults\"\r\n\t\t\t\tclass=\"m-filter-productsearch__dropdown-item m-filter-productsearch__dropdown-item--disabled\"\r\n\t\t\t\t[ngClass]=\"{'m-filter-productsearch__dropdown-item--no-results' : item.noResults, 'm-filter-productsearch__dropdown-item--label' : !item.noResults}\"\r\n\t\t\t\t[innerHtml]=\"item.name\">\r\n\t\t\t</li>\r\n\t\t</ng-container>\r\n\t</ul>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    FilterProductSearchComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: SearchAutoSuggestService }
    ]; };
    FilterProductSearchComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        searchButtonText: [{ type: Input }],
        enchancement: [{ type: Input }],
        _disabled: [{ type: Input }],
        searchConfig: [{ type: Input }],
        placeholder: [{ type: Input }],
        lang: [{ type: Input }],
        countryConfig: [{ type: Input }],
        permissionQuery: [{ type: Input }],
        searchChanges: [{ type: Output }],
        searchText: [{ type: Input }]
    };
    return FilterProductSearchComponent;
}());
export { FilterProductSearchComponent };
//# sourceMappingURL=filter-productsearch.component.js.map